module.exports = __webpack_public_path__ + "static/media/19_B.f3859798.png";